<template>
    <a class="go-home-button action left" href="#" v-if="isVisible">
        <i class="fal fa-home"></i>
    </a>
</template>

<script setup lang="ts">
    import { useTableAllocationStore } from "@/data/stores/tableAllocation";
    import { computed } from "vue";

    const tableAllocation = useTableAllocationStore();
    const isVisible = computed(() => !tableAllocation.isSingleService);
</script>
